function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddButon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Add Buton",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 337"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 145",
    width: 15,
    height: 15,
    rx: 2,
    style: {
      fill: "#ffa539"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 336"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 172",
    transform: "translate(3.338 7.5)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round"
    },
    d: "M0 0h8.324"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 173",
    transform: "translate(7.5 2.27)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round"
    },
    d: "M0 10.461V0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButon);
export default __webpack_public_path__ + "static/media/AddButon.672604159b75801892d588e7ef7182f4.svg";
export { ForwardRef as ReactComponent };